"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCluster = void 0;
const lumos_1 = require("@ckb-lumos/lumos");
const config_1 = require("../../../config");
const cobuild_1 = require("../../../cobuild");
const helpers_1 = require("../../../helpers");
const __1 = require("../..");
async function createCluster(props) {
    // Env
    const config = props.config ?? (0, config_1.getSporeConfig)();
    const indexer = new lumos_1.Indexer(config.ckbIndexerUrl, config.ckbNodeUrl);
    const capacityMargin = lumos_1.BI.from(props.capacityMargin ?? 1_0000_0000);
    const maxTransactionSize = props.maxTransactionSize ?? config.maxTransactionSize ?? false;
    // TransactionSkeleton
    let txSkeleton = lumos_1.helpers.TransactionSkeleton({
        cellProvider: indexer,
    });
    // Generate and inject Cluster cell
    const injectNewClusterResult = (0, __1.injectNewClusterOutput)({
        txSkeleton,
        data: props.data,
        toLock: props.toLock,
        updateOutput: props.updateOutput,
        capacityMargin,
        config,
    });
    txSkeleton = injectNewClusterResult.txSkeleton;
    // Inject needed capacity and pay fee
    const injectCapacityAndPayFeeResult = await (0, helpers_1.injectCapacityAndPayFee)({
        txSkeleton,
        fromInfos: props.fromInfos,
        changeAddress: props.changeAddress,
        updateTxSkeletonAfterCollection(_txSkeleton) {
            // Generate ID for the new Cluster (if possible)
            _txSkeleton = (0, __1.injectNewClusterIds)({
                txSkeleton: _txSkeleton,
                outputIndices: [injectNewClusterResult.outputIndex],
                config,
            });
            // Inject CobuildProof
            const clusterCell = txSkeleton.get('outputs').get(injectNewClusterResult.outputIndex);
            const clusterScript = (0, config_1.getSporeScript)(config, 'Cluster', clusterCell.cellOutput.type);
            if (clusterScript.behaviors?.cobuild) {
                const actionResult = (0, cobuild_1.generateCreateClusterAction)({
                    txSkeleton: _txSkeleton,
                    outputIndex: injectNewClusterResult.outputIndex,
                });
                const injectCobuildProofResult = (0, cobuild_1.injectCommonCobuildProof)({
                    txSkeleton: _txSkeleton,
                    actions: actionResult.actions,
                });
                _txSkeleton = injectCobuildProofResult.txSkeleton;
            }
            return _txSkeleton;
        },
        config,
    });
    txSkeleton = injectCapacityAndPayFeeResult.txSkeleton;
    // Make sure the tx size is in range (if needed)
    if (typeof maxTransactionSize === 'number') {
        (0, helpers_1.assertTransactionSkeletonSize)(txSkeleton, void 0, maxTransactionSize);
    }
    return {
        txSkeleton,
        outputIndex: injectNewClusterResult.outputIndex,
    };
}
exports.createCluster = createCluster;
//# sourceMappingURL=createCluster.js.map